/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */
// 免责声明
export const Disclaimer = 'https://bwg.zhenyekeji.com/aibuddy/agreement/user.html';
export const ReversoContext = 'https://bwg.zhenyekeji.com/aibuddy/agreement/privacy.html';
export const UserAgreement = 'https://bwg.zhenyekeji.com/aibuddy/agreement/user.html';

/**
 * @note 请求的 API Proxy Server(对应此 Demo 中包含的 Node server) 地址。
 *       您可按需改成自己需要访问的地址。
 */
export const AIGC_PROXY_HOST = '';
// export const AIGC_PROXY_HOST = 'https://chat.zhenyekeji.com/chatapi';

export interface IScene {
  icon: string;
  name: string;
  questions: string[];
  agentConfig: Record<string, any>;
  llmConfig: Record<string, any>;
  asrConfig: Record<string, any>;
  ttsConfig: Record<string, any>;
}
